<div class="app-header">
  <div class="left-menu">
    <p-sidebar [(visible)]="sidebarVisible" styleClass="w-20rem">
      <p-panelMenu [model]="items" [style]="{ width: '270px' }"></p-panelMenu>
    </p-sidebar>
    <button
      pButton
      class="menu-btn"
      (click)="sidebarVisible = true"
      icon="pi pi-align-justify"
      *ngIf="isAdmin"
    ></button>

    <div class="title">
      <img
        src="../../../../assets/favicon.png"
        alt="Icon"
        class="header-icon"
        (click)="routeToSearchSDSPage()"
      />
      <div (click)="routeToSearchSDSPage()" class="sds-title">{{ title }}</div>
      <div *ngIf="subTitle">{{ subTitle }}</div>
    </div>
  </div>
  <img src="../../assets/syensqo_logo.png" alt="Icon" class="solvay-icon" />

  <div class="right-div">
    <div class="menus clickable" (click)="showDialog()">
      <p-dialog
        [(visible)]="visible"
        [modal]="true"
        [style]="{ width: '60vw', height: '550px' }"
        [draggable]="false"
        [resizable]="false"
        (onHide)="hideDialog()"
        [transitionOptions]="'0ms'"
      >
        <div class="help-para">
          <h5>Preliminary remark:</h5>

          <p>
            This URL gives access to all the released SDS reports only and is
            updated every 6 hours. There is no possibility to retrieve some
            historical SDS if an update did happen in the meantime.
          </p>

          <h4 class="important-text">
            1. LANGUAGE selection - IMPORTANT remark about the language filter
          </h4>
          <p>
            Syensqo Safety Data Sheets (SDS) are edited in many
            languages. By default, all the SDS are edited in the country's
            official language(s):
          </p>
          <ul>
            <li>
              E.g. Belgium has 3 official languages so there are SDS in
              <ul>
                <li>DE - German</li>
                <li>FR - French</li>
                <li>NL - Dutch</li>
              </ul>
            </li>
            <li>
              E.g. France has a single official language so there are SDS in
              <ul>
                <li>FR - French</li>
              </ul>
            </li>
          </ul>
          <p>
            But in some cases, we can have an English version (not systematic)
            even if English is not an official language of this country. This
            happens often with non-Latin languages.
          </p>
          <ul>
            <li>
              E.g. South Korea:
              <ul>
                <li>KO - Korean</li>
                <li>EN - English</li>
              </ul>
            </li>
          </ul>

          <h5 class="tip-text">Tip:</h5>
          <p>
            As we understood that CARECHEM / CHEMTREC are mainly working with
            SDS edited in English, if there is no English version for the
            country, then the user should switch to the SDS version of an
            English spoken country close to the country where there is an
            accident:
          </p>
          <ul>
            <li>Eg Ireland can be the reference for Europe</li>
            <li>US English is the default language for North America</li>
          </ul>

          <p>
            About the English version, it's important to keep in mind that we
            maintain the next English languages:
          </p>
          <ul>
            <li>EN - English (GB English)</li>
            <li>Z8 - US English</li>
          </ul>
          <p>
            So as CARECHEM and CHEMTREC are covering different regions in the
            world,
          </p>
          <ul>
            <li>
              CHEMTREC: USA & Canada - use the Z8 US English language to get
              your SDS
            </li>
            <li>
              CARECHEM: All the world except USA & Canada - use the EN English
              to get your SDS.
            </li>
          </ul>
          <p>the default English is different for CARECHEM and CHEMTREC</p>
          <ul>
            <li>CHEMTREC => use the Z8 US english language to get your SDS</li>
            <li>CARECHEM => use the EN english to get your SDS.</li>
          </ul>

          <h4 class="important-text">2. COUNTRY selection</h4>
          <p>
            We assume by default that CARECHEM and CHEMTREC are covering
            different regions in the world as indicated by the contracts with Syensqo:
          </p>
          <ul>
            <li>CHEMTREC: USA & Canada</li>
            <li>CARECHEM: All the world except USA & Canada</li>
          </ul>
          <p class="red-text">
            Even if it is not mandatory, it is recommended to preselect language
            and country to reduce the search on the database. Indeed, the speed
            of the response will depend on it and the length of the output list
            could be more easy to manage.
          </p>

          <h4 class="important-text">3. Material code</h4>
          <p>
            Many transport documents (IATA, IMDG, ADR, RID, CFR, TDG … transport
            regulations) mention the material code in the delivery. This info
            can eventually be used to directly get the SDS related to this
            material.
          </p>
          <p>The code is a pure digit # and doesn't allow any letter.</p>

          <h4 class="important-text">
            4. Main search field (Search by product or title or name, …)
          </h4>
          <p>This field allows many searches with alphanumeric characters:</p>
          <ul>
            <li>Search by the product's commercial name</li>
            <li>Search by the product's grade</li>
            <li>Search by the product chemical description</li>
            <li>Search by the product code</li>
            <li>Search by UN# is even allowed</li>
          </ul>
          <p>
            It's recommended to make search with English terms only - Search
            happens on the SDS metadata list but also on the SDS report content
            itself. So some outputs can be listed because there is a match in
            the report itself even if there is no match with the metadata.
          </p>

          <p>
            Combinations of search terms with some AND/OR logic aren't allowed.
          </p>
        </div>
      </p-dialog>
      <h5>HELP</h5>
      <i class="pi pi-question-circle help-icon"></i>
    </div>
    <div class="menus clickable" (click)="op.toggle($event)">
      <p-overlayPanel #op>
        <ng-template pTemplate="button">
          <h4 (click)="logout()">Logout</h4>
        </ng-template>
      </p-overlayPanel>
      <i class="pi pi-user"></i>
    </div>
  </div>
</div>
